import * as api from 'shared/models/api';
import {
  parentCategories,
  defaultIngredientOption
} from 'shared/models/product';

export const GET_PRODUCT = 'GET_PRODUCT';
export const PRODUCT_LOADING = 'PRODUCT_LOADING';
export const PREVIEW_PRODUCT = 'PREVIEW_PRODUCT';
export const GET_PRODUCT_PRICES = 'GET_PRODUCT_PRICES';
export const PRODUCT_PARENT_CATEGORIES = 'PRODUCT_PARENT_CATEGORIES';
export const GET_BOUGHT_WITH = 'GET_BOUGHT_WITH';
export const BOUGHT_WITH_LOADING = 'BOUGHT_WITH_LOADING';
export const GET_SIMILAR_PRODUCTS = 'GET_SIMILAR_PRODUCTS';
export const SIMILAR_PRODUCTS_LOADING = 'SIMILAR_PRODUCTS_LOADING';
export const GET_MORE_BY_BRAND = 'GET_MORE_BY_BRAND';
export const MORE_BY_BRAND_LOADING = 'MORE_BY_BRAND_LOADING';
export const SELECT_INGREDIENT_OPTION = 'SELECT_INGREDIENT_OPTION';
export const LOAD_RATINGS = 'LOAD_RATINGS';

const initialState = {
  product: {},
  productLoading: false,
  previewingProduct: false,
  parentCategories: [],
  similarProducts: [],
  similarProductsLoading: false,
  moreByBrand: [],
  moreByLoading: false,
  boughtWith: [],
  boughtWithLoading: false,
  ratings: {},
  selectedIngredients: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_PRODUCT:
      return {
        ...state,
        product: action.product,
        previewingProduct: false,
        productLoading: false,
        selectedIngredients: (action.product.ingredients || []).map(i => ({
          name: i.name,
          _id: i._id,
          selected: defaultIngredientOption(i)
        }))
      };
    case PREVIEW_PRODUCT:
      return {
        ...state,
        product: action.product,
        previewingProduct: true
      };
    case PRODUCT_LOADING:
      return { ...state, productLoading: true };
    case GET_PRODUCT_PRICES:
      return {
        ...state,
        product: {
          ...state.product,
          minPrice: action.minPrice,
          maxPrice: action.maxPrice
        }
      };
    case PRODUCT_PARENT_CATEGORIES:
      return { ...state, parentCategories: action.categories };
    case SIMILAR_PRODUCTS_LOADING:
      return { ...state, similarProductsLoading: true };
    case GET_SIMILAR_PRODUCTS:
      return {
        ...state,
        similarProducts: action.products,
        similarProductsLoading: false
      };
    case MORE_BY_BRAND_LOADING:
      return { ...state, moreByBrandLoading: true };
    case GET_MORE_BY_BRAND:
      return {
        ...state,
        moreByBrand: action.products.filter(
          p => p.sku_id !== state.product.sku_id
        ),
        moreByBrandLoading: false
      };
    case BOUGHT_WITH_LOADING:
      return { ...state, boughtWithLoading: true };
    case GET_BOUGHT_WITH:
      return {
        ...state,
        boughtWith: action.products,
        boughtWithLoading: false
      };
    case LOAD_RATINGS:
      return { ...state, ratings: action.ratings };
    case SELECT_INGREDIENT_OPTION:
      return {
        ...state,
        selectedIngredients: state.selectedIngredients.map(i => {
          return i._id === action.ingredient._id
            ? { name: i.name, _id: i._id, selected: action.product }
            : i;
        })
      };
    default:
      return state;
  }
}

let _productRequest;

export function fetchProduct(sku) {
  return dispatch => {
    dispatch({ type: PRODUCT_LOADING });

    if (_productRequest && _productRequest.isPending())
      _productRequest.cancel();

    _productRequest = api.getProduct(sku).then(function(res) {
      const product = res || {};
      dispatch({ type: GET_PRODUCT, product });
      return product;
    });

    return _productRequest;
  };
}

export function previewVariant(variant, currentProduct) {
  return dispatch => {
    const previewProduct = {
      volume_variants: currentProduct.volume_variants,
      categoryUrl: currentProduct.categoryUrl,
      category: currentProduct.category,
      company: currentProduct.company,
      brand: currentProduct.brand,
      brandUrl: currentProduct.brandUrl,
      title: currentProduct.title,
      ...variant
    };

    return dispatch({
      type: PREVIEW_PRODUCT,
      product: previewProduct
    });
  };
}

export function getPrices(sku) {
  return dispatch => {
    return api.getProductPrices(sku).then(prices => {
      return dispatch({
        type: GET_PRODUCT_PRICES,
        minPrice: prices.min,
        maxPrice: prices.max
      });
    });
  };
}

export function getParentCategories() {
  return (dispatch, getState) => {
    return api.fetchCategoryList().then(list => {
      const product = getState().product.product;
      const categories = parentCategories(product, list);
      dispatch({ type: PRODUCT_PARENT_CATEGORIES, categories });
    });
  };
}

export function getSimilarProducts(sku) {
  return dispatch => {
    dispatch({ type: SIMILAR_PRODUCTS_LOADING });
    return api.getSimilarProducts(sku).then(similarProducts => {
      dispatch({ type: GET_SIMILAR_PRODUCTS, similarProducts });
    });
  };
}

export function getMoreByBrand(brand) {
  return dispatch => {
    if (!brand) return dispatch({ type: GET_MORE_BY_BRAND, products: [] });
    dispatch({ type: MORE_BY_BRAND_LOADING });
    return api.getBrandProducts(brand, true).then(res => {
      const products = res.products || [];
      dispatch({ type: GET_MORE_BY_BRAND, products });
    });
  };
}

export function getRelatedProducts(sku) {
  return dispatch => {
    dispatch({ type: MORE_BY_BRAND_LOADING });
    dispatch({ type: SIMILAR_PRODUCTS_LOADING });
    dispatch({ type: BOUGHT_WITH_LOADING });
    return api.getRelatedProducts(sku).then(res => {
      dispatch({ type: GET_MORE_BY_BRAND, products: res.brands });
      dispatch({ type: GET_SIMILAR_PRODUCTS, products: res.similar });
      dispatch({ type: GET_BOUGHT_WITH, products: res.fbt });
    });
  };
}

export function loadRatings(ratings) {
  return dispatch => {
    return dispatch({ type: LOAD_RATINGS, ratings });
  };
}

export function selectIngredientOption(ingredient, product) {
  return dispatch => {
    return dispatch({ type: SELECT_INGREDIENT_OPTION, ingredient, product });
  };
}



// WEBPACK FOOTER //
// ./shared/components/product/actions.js